import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('ARTICLES', ['newest', 'proposal', 'inprogress', 'prewritten', 'postpublished', 'fixed', 'template', 'restricted']);
